import fr from 'facet-rest';
import BaseOverride from './BaseOverride';

const ChooseIncomeCategoriesOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('options', {
    hidden: true,
    _transformValue: () => (value, values, resource) => {
      const metaField = resource.meta().field('options');
      const noneOpt = metaField.options().list().find(opt => opt.attr('prompt') === 'None');

      if (!noneOpt) {
        return values;
      }

      if (value === noneOpt.id()) {
        // Remove all other items from the list
        return values.filter(item => item === noneOpt.id());
      }

      if (value !== noneOpt.id()) {
        // Remove the None selection
        return values.filter(item => item !== noneOpt.id());
      }
      return values;
    },
  });

export default ChooseIncomeCategoriesOverride;
